async function clippie(content, { reject = false } = {}) {
  var _a;
  try {
    if (Array.isArray(content)) {
      if (!((_a = navigator == null ? void 0 : navigator.clipboard) == null ? void 0 : _a.write)) {
        for (const c of content) {
          if (typeof c === "string") fallback(c);
        }
      }
      await navigator.clipboard.write([
        new ClipboardItem(Object.fromEntries(content.map((c) => {
          return [(c == null ? void 0 : c.type) ?? "text/plain", c];
        })))
      ]);
      return true;
    } else if (content instanceof Blob) {
      await navigator.clipboard.write([new ClipboardItem({ [content.type]: content })]);
      return true;
    } else {
      try {
        await navigator.clipboard.writeText(String(content));
        return true;
      } catch {
        return fallback(content);
      }
    }
  } catch (err) {
    if (reject) throw err;
    return false;
  }
}
function fallback(content) {
  if (!document.execCommand) return false;
  const el = document.createElement("textarea");
  el.value = String(content);
  el.style.clipPath = "inset(50%)";
  el.ariaHidden = "true";
  document.body.append(el);
  try {
    el.select();
    return document.execCommand("copy");
  } finally {
    el.remove();
  }
}
export {
  clippie
};
